let Months = [
  {
    monthName: "January",
  },
  {
    monthName: "February",
  },
  {
    monthName: "March",
  },
  {
    monthName: "April",
  },
  {
    monthName: "May",
  },
  {
    monthName: "June",
  },

  {
    monthName: "July",
  },
  {
    monthName: "August",
  },
  {
    monthName: "September",
  },
  {
    monthName: "October",
  },
  {
    monthName: "November",
  },
  {
    monthName: "December",
  },
];

export default Months;
